import React from 'react';
import { Column } from './simpleTable';
import {
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material';

export interface TableHeaderProps<T extends any> {
  columns: Column<T>[];
  asAction?: boolean;
  withCheckBox?: boolean;
  onCheckAllRows?(isAllChecked: boolean): void;
  areAllRowsChecked?: boolean;
}

export function TableHeader<T extends any>({
  columns,
  asAction,
  withCheckBox = false,
  onCheckAllRows,
  areAllRowsChecked = false,
}: TableHeaderProps<T>) {
  return (
    <TableHead style={{ backgroundColor: '#F6F7F9' }}>
      <TableRow>
        {withCheckBox && (
          <TableCell padding='checkbox' align='left'>
            <Checkbox
              color='primary'
              sx={{
                '&.Mui-checked .MuiSvgIcon-root': {
                  border: '2px solid #3490dc',
                  borderRadius: '5px',
                },
              }}
            
              checked={areAllRowsChecked}
              onChange={() => onCheckAllRows && onCheckAllRows(!areAllRowsChecked)}
            />
          </TableCell>
        )}
        {columns.map((item) => (
          <TableCell key={item.field} align='left' sx={{ padding: '10px', color: '#344054' }}>
            <TableSortLabel>{item.title}</TableSortLabel>
          </TableCell>
        ))}
        {asAction && <TableCell key='Actions' align='left' sx={{ padding: '10px', color: '#344054' }}>Actions</TableCell>}
      </TableRow>
    </TableHead>
  );
}
